import styled from '@emotion/styled'

export const Content = styled('div')`
  padding-top: 10px;
  color: #666666;
`